import React from 'react';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { formatDate } from '../../../../../utils/dateFunctions';
import { uuid } from '../../../../../utils/stringUtils';

import pdf from '../../../../../commonStyles/pdf.module.css';

const AppointmentDetails = ({ currentAppointment, appointment, nextAppointment, ptCode }) => {
    const documentId =
        currentAppointment?.calendarAppointmentId?.slice(-9) || uuid().slice(-9) || '-';
    const dateConducted = currentAppointment.attendanceTime.split(',')[0] || '-';
    const timeStarted = currentAppointment.attendanceTime.split(',')[1] || '-';
    const timeEnded = format(new Date(), `HH :mm`).replace(/:/g, ' : ');
    const appointmentDate = formatDate(new Date(appointment.date));

    const { firstName, lastName } = useSelector((state) => state.entities.userService.loggedInUser);
    const name = `${firstName} ${lastName}`;

    // RENDER
    return (
        <div className={pdf.dualColumnSet} data-testid="appointment-details">
            <div className={pdf.column}>
                <div className={pdf.row}>
                    <span>Appointment:</span>
                    <span>{appointment?.type || '-'}</span>
                </div>
                <div className={pdf.row}>
                    <span>Appointment status:</span>
                    <span>{currentAppointment?.attendanceName || '-'}</span>
                </div>
                <div className={pdf.row}>
                    <span>Mandated:</span>
                    <span>{appointment?.mandatory ? 'Yes' : 'No'}</span>
                </div>
                <div className={pdf.row}>
                    <span>Document ID:</span>
                    <span>{documentId}</span>
                </div>
                <div className={pdf.row}>
                    <span>Date Conducted:</span>
                    <span>{dateConducted}</span>
                </div>
                <div className={pdf.row}>
                    <span>Time Started:</span>
                    <span>{timeStarted}</span>
                </div>
                <div className={pdf.row}>
                    <span>Time Ended:</span>
                    <span>{timeEnded}</span>
                </div>
                <div className={pdf.row}>
                    <span>Adviser:</span>
                    <span>{name}</span>
                </div>
                <div className={pdf.row}>
                    <span>PT ID:</span>
                    <span>{ptCode}</span>
                </div>
            </div>

            <div className={pdf.column}>
                <div className={pdf.row}>
                    <span>Date of Appointment:</span>
                    <span>{appointmentDate}</span>
                </div>
                <div className={pdf.row}>
                    <span>Time of Appointment:</span>
                    <span>{appointment.startTime}</span>
                </div>
                <br />
                {nextAppointment && (
                    <div className={pdf.row}>
                        <span>Next Appointment:</span>
                        <span>{nextAppointment?.appointmentType || '-'}</span>
                    </div>
                )}
                {nextAppointment.date && (
                    <div className={pdf.row}>
                        <span>Date:</span>
                        <span>{nextAppointment.date || '-'}</span>
                    </div>
                )}
                {nextAppointment.startTime && (
                    <div className={pdf.row}>
                        <span>Time:</span>
                        <span>{nextAppointment.startTime?.replace(/:/g, ' : ') || '-'}</span>
                    </div>
                )}
            </div>
        </div>
    );
};

AppointmentDetails.propTypes = {
    currentAppointment: PropTypes.object,
    appointment: PropTypes.object,
    nextAppointment: PropTypes.object,
    ptCode: PropTypes.string
};

export default AppointmentDetails;
